// extracted by mini-css-extract-plugin
export var chevronIcon = "_9m-2";
export var teamName = "_9m-1";
export var teamSwitcherButton = "_9m-0";